import { render, staticRenderFns } from "./PeriodsUpdate.vue?vue&type=template&id=2e735a7f"
import script from "./PeriodsUpdate.vue?vue&type=script&lang=js"
export * from "./PeriodsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports